import { LicenseManager } from "ag-grid-enterprise";

const licenseKey =
  "CompanyName=Global Groupware Solutions Ltd.,LicensedApplication=EmployWise,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-017444,ExpiryDate=20_July_2022_[v2]_MTY1ODI3MTYwMDAwMA==2e10ea9648708d9533c5a674d1c2ce0e";

LicenseManager.setLicenseKey(licenseKey);
